import localStorage from "src/utils/local-storage";
import { create } from "zustand";
import { useShallow } from "zustand/shallow";

export type MerchantIdState = {
	merchantId: string | null;
	setMerchantId: (merchantId: string | null) => void;
};

const useMerchantIdStore = create<MerchantIdState>((set) => ({
	merchantId: localStorage.get("merchantId"),
	setMerchantId: (merchantId: string | null) => {
		set({ merchantId });
		if (merchantId) {
			localStorage.set("merchantId", merchantId);
		} else {
			localStorage.remove("merchantId");
		}
	},
}));

export const useActiveMerchantId = () =>
	useMerchantIdStore(
		useShallow((s) => ({
			merchantId: s.merchantId,
			setMerchantId: s.setMerchantId,
		})),
	);

export default useActiveMerchantId;
